import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { GlobalState } from '../../../shared/global.state';
import { TeacherService } from '../../../shared/services/teacher.services';
@Component({
  selector: 'app-edit-profile-dialog',
  templateUrl: 'edit-profile-dialog.component.html',
  styleUrls: ['edit-profile-dialog.component.scss']
})
export class EditProfileDialogComponent {
  user: any = {};
  public form: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<EditProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _state: GlobalState,
    private teacherService: TeacherService
  ) { }

  onCancleClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      position: ['', Validators.required],
      name: ['', Validators.required],
      surname: ['', Validators.required],
    });
    this.user = {
      id: this.data.user.id,
      majorName: this.data.user.majorName,
      officerCode: this.data.user.officerCode,
      officerLogin: this.data.user.officerLogin,
      officerName: this.data.user.officerName,
      officerNameEng: this.data.user.officerNameEng,
      officerSurname: this.data.user.officerSurname,
      officerSurnameEng: this.data.user.officerSurnameEng,
      officerPosition: this.data.user.officerPosition,
      officerType: this.data.user.officerType
    }
  }
  onSubmit(data) {
    this.teacherService.updateTeacherInfo(this.user['id'], this.user).subscribe((result) => {
      this.teacherService.resetInfo();
      this.dialogRef.close();
    });
  }
}
